import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import { useDimensions } from '../../hooks';
import { Overlay } from '../Overlay';
import { Icon } from '../Icon';
import clsx from 'clsx';
import { Icons } from '../../types/icons';
const Drawer = ({ children, open, setOpen, anchor = 'left', customClassName = '', inlineStyles = {}, }) => {
    const classes = useStyles();
    const { isMobile } = useDimensions();
    const containerStyle = clsx({
        [classes.container]: true,
        [classes[anchor]]: true,
        [classes.mobile]: isMobile,
        [customClassName]: Boolean(customClassName)
    });
    if (!open)
        return null;
    return (React.createElement(Overlay, null,
        React.createElement("div", { className: containerStyle, style: Object.assign({}, inlineStyles) },
            React.createElement("div", { className: classes.content },
                React.createElement(Icon, { onClick: () => setOpen(false), name: Icons.Close }),
                children))));
};
Drawer.propTypes = {
    children: PropTypes.node,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    anchor: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
    customClassName: PropTypes.string,
    inlineStyles: PropTypes.object,
    animationConfig: PropTypes.shape({
        from: PropTypes.object,
        enter: PropTypes.object.isRequired,
        leave: PropTypes.object,
        config: PropTypes.object
    }),
    onClickOverlay: PropTypes.func,
    closeOnOverlayClick: PropTypes.bool
};
export { Drawer };
//# sourceMappingURL=Drawer.js.map